module.exports = __webpack_public_path__ + "img/Examination.1846288d.svg";